export default __webpack_public_path__ + "locales/el-GR/Common.json?hash=9525e63cd1b0a7c712f64404530c0610";